module.exports = __webpack_public_path__ + "assets/img/text-to-speech-app1.fc974eab.png";